var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStakingIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 7.61667C13.2833 6.625 12.4583 5.83333 11.4583 5.83333H10.8333V4.16667C10.8333 1.86917 8.96417 0 6.66667 0C4.36917 0 2.5 1.86917 2.5 4.16667V5.83333H1.875C0.841667 5.83333 0 6.675 0 7.70833V14.7917C0 15.825 0.841667 16.6667 1.875 16.6667H7.80833C7.60833 16.0083 7.5 15.3083 7.5 14.5833C7.5 11.1 10.0167 8.2 13.3333 7.61667ZM4.16667 5.83333V4.16667C4.16667 2.78833 5.28833 1.66667 6.66667 1.66667C8.045 1.66667 9.16667 2.78833 9.16667 4.16667V5.83333H4.16667Z",
    fill: "grey"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5833 9.16667C11.5967 9.16667 9.16667 11.5967 9.16667 14.5833C9.16667 17.57 11.5967 20 14.5833 20C17.57 20 20 17.57 20 14.5833C20 11.5967 17.57 9.16667 14.5833 9.16667ZM16.4225 16.4225C16.26 16.585 16.0467 16.6667 15.8334 16.6667C15.62 16.6667 15.4067 16.585 15.2442 16.4225L13.9942 15.1725C13.8375 15.0167 13.75 14.8042 13.75 14.5833V12.5C13.75 12.04 14.1233 11.6667 14.5833 11.6667C15.0433 11.6667 15.4167 12.04 15.4167 12.5V14.2383L16.4225 15.2442C16.7484 15.57 16.7484 16.0967 16.4225 16.4225Z",
    fill: "grey"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStakingIcon);
export default __webpack_public_path__ + "static/media/stakingIcon.bbbf85f3085a0fbb88a7864bda29a691.svg";
export { ForwardRef as ReactComponent };